import React from "react";
import { Button, Divider, Grid, Paper, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const facialDataParagraphs = [
	"La aplicación puede capturar imágenes del rostro del usuario mediante la cámara del dispositivo con la única finalidad de verificar su identidad durante el proceso de control de presencia.",
	"La aplicación no utiliza los datos faciales para crear perfiles publicitarios, seguimiento comercial, análisis de comportamiento ni identificación con fines distintos al control de presencia autorizado por la empresa.",
	"Las imágenes o datos relacionados con la verificación facial se transmiten de forma segura al servidor de la empresa para realizar la comprobación de identidad. Estos datos no se venden ni se comparten con terceros con fines comerciales o publicitarios.",
	"El tratamiento técnico de la verificación facial puede realizarse mediante sistemas internos o servicios tecnológicos autorizados exclusivamente para prestar la funcionalidad de validación de identidad. En ese caso, dichos proveedores actúan únicamente como encargados del tratamiento y no pueden usar los datos para fines propios.",
	"Los datos faciales se almacenan únicamente durante el tiempo necesario para realizar la verificación, justificar el registro de control de presencia y cumplir con las obligaciones legales, laborales o contractuales aplicables. Transcurrido dicho periodo, los datos serán eliminados o anonimizados de acuerdo con la política interna de conservación de datos.",
	"El usuario puede contactar con el responsable del tratamiento para solicitar información sobre el uso de sus datos, así como ejercer sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad, cuando proceda.",
];

export const PoliticaPrivacidad = () => {
	return (
		<Grid
			container
			justifyContent="center"
			sx={{ minHeight: "80vh", px: 2, py: { xs: 4, md: 6 } }}
		>
			<Grid size={{ xs: 12, md: 10, lg: 8, xl: 7 }}>
				<Paper
					elevation={3}
					sx={{
						p: { xs: 3, md: 5 },
						borderRadius: 3,
						backgroundColor: "var(--fondoTarjeta)",
					}}
				>
					<Grid container direction="column" gap={3}>
						<Grid>
							<Typography variant="h3" color="primary" gutterBottom>
								Politica de privacidad
							</Typography>
							<Typography variant="body1" sx={{ color: "text.secondary" }}>
								Esta politica describe de forma general como se tratan los datos
								personales utilizados por la aplicacion para prestar sus funciones
								de acceso, gestion y control de presencia.
							</Typography>
						</Grid>

						<Divider />

						<Grid container direction="column" gap={1.5}>
							<Typography variant="h5" color="primary">
								Informacion general
							</Typography>
							<Typography variant="body1">
								Los datos personales tratados a traves de la aplicacion se usan
								exclusivamente para gestionar el servicio, autenticar el acceso de
								los usuarios, registrar la actividad autorizada y cumplir con las
								obligaciones legales, laborales o contractuales que resulten
								aplicables.
							</Typography>
							<Typography variant="body1">
								La empresa responsable del servicio aplica medidas tecnicas y
								organizativas razonables para proteger la informacion y limitar el
								acceso a personal autorizado.
							</Typography>
						</Grid>

						<Divider />

						<Grid container direction="column" gap={1.5}>
							<Typography variant="h5" color="primary">
								Datos faciales
							</Typography>
							{facialDataParagraphs.map((paragraph) => (
								<Typography key={paragraph} variant="body1">
									{paragraph}
								</Typography>
							))}
						</Grid>

						<Divider />

						<Grid container direction="column" gap={1.5}>
							<Typography variant="h5" color="primary">
								Ejercicio de derechos
							</Typography>
							<Typography variant="body1">
								El usuario puede solicitar informacion adicional sobre esta
								politica o ejercer sus derechos mediante los canales de contacto
								habilitados por la empresa responsable del tratamiento.
							</Typography>
						</Grid>

						<Grid container justifyContent="flex-start">
							<Button component={RouterLink} to="/login" variant="outlined" color="primary">
								Volver al acceso
							</Button>
						</Grid>
					</Grid>
				</Paper>
			</Grid>
		</Grid>
	);
};
